import React, { ChangeEvent, JSX } from "react";
import { ObjectState } from "../../../../utils/states/ConstructorPageStates/ObjectState";
import { PropertyState } from "../../../../utils/states/ConstructorPageStates/PropertyState";
import { PropertyType } from "../../../../utils/enums/PropertyType";
import { DEFAULT_GAME_IMAGE } from "../../../../utils/constants/constants";

interface PropertyColumnProps {
  property: PropertyState;
  objects: ObjectState[];
  editedProperty: PropertyState | null;
  editedObject?: ObjectState | null;
  handlePropertyClicked: (property: PropertyState) => void;
  handleDragStart: (
    e: React.DragEvent<HTMLDivElement>,
    propertyId: number
  ) => void;
  handleDragEnter: (
    e: React.DragEvent<HTMLDivElement>,
    propertyId: number
  ) => void;
  handleDragLeave: () => void;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>, propertyId: number) => void;
  handleDragEnd: (e: React.DragEvent<HTMLDivElement>) => void;
  handleChangeObjectValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
  titleRefs: React.RefObject<(HTMLDivElement | null)[]>;
  index: number;
  propertyRef: React.RefObject<HTMLDivElement | null>;
  handleObjectValueImageUpload: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const PropertyColumn = ({
  property,
  objects,
  editedProperty,
  editedObject,
  handlePropertyClicked,
  handleDragStart,
  handleDragEnter,
  handleDragLeave,
  handleDragOver,
  handleDrop,
  handleDragEnd,
  handleChangeObjectValue,
  titleRefs,
  index,
  propertyRef,
  handleObjectValueImageUpload,
}: PropertyColumnProps) => {
  const generateInputForEdit = (
    property: PropertyState,
    object: ObjectState
  ): JSX.Element => {
    const value = object.properties[property.id].value;
    switch (property.type) {
      case PropertyType.Integer:
        return (
          <input
            autoComplete="off"
            type="number"
            name={`${object.id}_${property.id}`}
            className="constructor_table__edited_property_value_input game_text"
            onChange={handleChangeObjectValue}
            value={value}
            onClick={(e) => e.stopPropagation()}
          />
        );
      case PropertyType.Image:
        return (
          <div className="constructor_table__edited_property_image_value">
            <label
              htmlFor={`propertyImageUploadInput${property.id}${object.id}`}
              style={{ cursor: "pointer", display: "block" }}
            >
              <img
                className="constructor_table__image_view"
                src={value ? String(value) : DEFAULT_GAME_IMAGE}
                onClick={(e) => e.stopPropagation()}
                alt="Изображение для загрузки"
              />
            </label>
            <input
              autoComplete="off"
              id={`propertyImageUploadInput${property.id}${object.id}`}
              type="file"
              onChange={handleObjectValueImageUpload}
              name={`${object.id}_${property.id}`}
              className="constructor_table__image_input game_text"
              accept="image/*"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        );
      case PropertyType.String:
        return (
          <input
            autoComplete="off"
            type="text"
            name={`${object.id}_${property.id}`}
            className="constructor_table__edited_property_value_input game_text"
            onChange={handleChangeObjectValue}
            value={value}
            onClick={(e) => e.stopPropagation()}
          />
        );
      case PropertyType.Date:
        return (
          <input
            autoComplete="off"
            type="date"
            name={`${object.id}_${property.id}`}
            className="constructor_table__edited_property_value_input game_text"
            onChange={handleChangeObjectValue}
            value={value}
            onClick={(e) => e.stopPropagation()}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <div
      className={
        editedProperty?.id === property.id
          ? "constructor_table__property_column edited editedImage"
          : "constructor_table__property_column"
      }
      ref={(el) => {
        if (editedProperty?.id === property.id) {
          propertyRef.current = el;
        }
      }}
      key={property.id}
      draggable="true"
      onClick={() => handlePropertyClicked(property)}
      onDragStart={(e) => handleDragStart(e, property.id)}
      onDragEnter={(e) => handleDragEnter(e, property.id)}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={(e) => handleDrop(e, property.id)}
      onDragEnd={handleDragEnd}
    >
      <div
        className="constructor_table__property_title game_header"
        ref={(el) => {
          titleRefs.current[index + 1] = el;
        }}
      >
        {property.name}
      </div>
      <div
        className={
          editedProperty?.id === property.id
            ? "constructor_table__property_separator editedSeparator"
            : "constructor_table__property_separator"
        }
      />
      {objects.map((object) => {
        const isEditingObject = editedObject && editedObject.id === object.id;
        const isEditingProperty =
          editedProperty && editedProperty.id === property.id;
        const isEditing = isEditingObject || isEditingProperty;

        return (
          <div
            className={
              object.properties[property.id].value === ""
                ? "constructor_table__property_value incorrect"
                : "constructor_table__property_value"
            }
            key={object.id}
          >
            {isEditing && generateInputForEdit(property, object)}
            {
              <div
                style={{
                  display: isEditing
                    ? "none"
                    : property.type === PropertyType.Image
                    ? "block"
                    : "none",
                }}
                className="constructor_table__edited_property_image_value"
              >
                <img
                  className="constructor_table__image_view"
                  src={
                    object.properties[property.id].value
                      ? String(object.properties[property.id].value)
                      : DEFAULT_GAME_IMAGE
                  }
                  alt="Изображение для загрузки"
                />
              </div>
            }
            {
              <span
                style={{
                  display: isEditing
                    ? "none"
                    : property.type === PropertyType.Image
                    ? "none"
                    : "block",
                }}
                className="game_text"
              >
                {object.properties[property.id].value}
              </span>
            }
          </div>
        );
      })}
    </div>
  );
};
